import { render } from "./ChengBenLiRun.vue?vue&type=template&id=42befb34&scoped=true"
import script from "./ChengBenLiRun.vue?vue&type=script&lang=js"
export * from "./ChengBenLiRun.vue?vue&type=script&lang=js"

import "./ChengBenLiRun.vue?vue&type=style&index=0&id=42befb34&scoped=true&lang=css"

import exportComponent from "D:\\fxwl\\wx-wl_full\\wx-wl_full\\fxwl\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42befb34"]])

export default __exports__